import type { GuildHasFeature } from "../../types/experiment";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Button } from "../ui/button";
import { X } from "lucide-react";

interface GuildHasFeatureFilterProps {
  value: GuildHasFeature;
  onChange: (value: GuildHasFeature) => void;
}

export function GuildHasFeatureFilter({ value, onChange }: GuildHasFeatureFilterProps) {
  const addFeature = () => onChange({ ...value, features: [...value.features, ""] });
  const updateFeature = (i: number, v: string) => {
    const next = [...value.features];
    next[i] = v;
    onChange({ ...value, features: next });
  };
  const removeFeature = (i: number) =>
    onChange({ ...value, features: value.features.filter((_, j) => j !== i) });

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label className="text-xs">Features</Label>
        <Button type="button" variant="outline" size="sm" onClick={addFeature}>
          Add Feature
        </Button>
      </div>
      {value.features.map((feat, i) => (
        <div key={i} className="flex items-center gap-2">
          <Input
            value={feat}
            onChange={(e) => updateFeature(i, e.target.value)}
            placeholder="feature_name"
            className="flex-1"
          />
          <Button type="button" variant="ghost" size="icon" onClick={() => removeFeature(i)}>
            <X className="h-4 w-4 text-red" />
          </Button>
        </div>
      ))}
    </div>
  );
}
